@if (computedTotalPages > 1) {
  <nav class="pagination" role="navigation" aria-label="Navegación de páginas">
    <!-- Botón Anterior -->
    <button
      type="button"
      class="pagination-button"
      (click)="previousPage()"
      [disabled]="page <= 1"
      aria-label="Página anterior"
    >
      ←
    </button>

    <!-- Botones de Página con soporte de Elipsis -->
    @for (p of visiblePages; track $index) {
      @if (p === -1) {
        <span class="pagination-ellipsis" aria-hidden="true">…</span>
      } @else {
        <button
          type="button"
          class="pagination-button"
          [class.active]="page === p"
          (click)="goToPage(p)"
          [attr.aria-current]="page === p ? 'page' : null"
          [attr.aria-label]="'Ir a la página ' + p"
        >
          {{ p }}
        </button>
      }
    }

    <!-- Botón Siguiente -->
    <button
      type="button"
      class="pagination-button"
      (click)="nextPage()"
      [disabled]="page >= computedTotalPages"
      aria-label="Página siguiente"
    >
      →
    </button>
  </nav>
}
